import React, { useState, useEffect, useRef } from 'react';
import Header from '../../Header';
import Footer from '../../Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import config from "../../common/Config";
import Swal from 'sweetalert2';
import ExportProductList from './ExportProductList';
import { setTableWidths, getTableWidths } from "../../../data/postAPi";

const AllProductList = ({ refresh }) => {
	const allPdtRef = useRef(null);
	const [searchValue, setSearchValue] = useState([]);
	const accessToken = localStorage.getItem('accessToken');
	const [totalActiveProduct, setTotalActiveProduct] = useState('');
	const [totalboxProduct, setTotalboxProduct] = useState("");
	const [totalpieceProduct, setTotalpieceProduct] = useState("");

	// Column width management
	const [columnWidths, setColumnWidths] = useState({
		0: 70,
		1: 200,
		2: 150,
		3: 130,
		4: 80,
		5: 60,
		6: 60,
		7: 75,
		8: 45,
		9: 60,
		10: 60,
		11: 75,
		12: 45,
		13: 55
	});
	const [widthsLoaded, setWidthsLoaded] = useState(false);
	const userId = localStorage.getItem("userId");
	const tableName = "allProductListTable";

	function debounce(func, wait) {
		let timeout;
		return function (...args) {
			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(this, args), wait);
		};
	}

	const debouncedSetTableWidths = useRef(
		debounce((userId, tableName, widths) => {
			setTableWidths(userId, tableName, Object.values(widths));
		}, 500)
	).current;

	// On mount, fetch widths before DataTable init
	useEffect(() => {
		(async function fetchWidths() {
			try {
				const res = await getTableWidths(userId, tableName);
				if (res?.data?.widths && Array.isArray(res.data.widths) && res.data.widths.length > 0) {
					const arr = res.data.widths;
					const obj = {};
					for (let i = 0; i < arr.length; i++) obj[i] = arr[i];
					setColumnWidths(obj);
				}
			} catch (e) { }
			setWidthsLoaded(true);
		})();
	}, []);

	// Whenever columnWidths changes, apply to table
	useEffect(() => {
		applyColumnWidths();
	}, [columnWidths]);

	const resizeRef = useRef({
		isResizing: false,
		startX: 0,
		startWidth: 0,
		columnIndex: -1,
		table: null
	});

	const initializeResizers = () => {
		const table = allPdtRef.current;
		if (!table) return;

		// Only select the last header row (actual column headers)
		const headerRows = table.querySelectorAll('thead tr');
		if (!headerRows.length) return;
		const lastHeaderRow = headerRows[headerRows.length - 1];
		const headers = lastHeaderRow.querySelectorAll('th');

		headers.forEach((header, index) => {
			if (index === headers.length - 1) return;
			// Remove any existing resizer to avoid duplicates
			const existingResizer = header.querySelector('.column-resizer');
			if (existingResizer) header.removeChild(existingResizer);
			const resizer = document.createElement('div');
			resizer.className = 'column-resizer';
			resizer.style.cssText = `
        position: absolute;
        top: 0;
        right: 0;
        width: 5px;
        height: 100%;
        cursor: col-resize;
        background: transparent;
        z-index: 10;
        user-select: none;
      `;
			header.style.position = 'relative';
			header.appendChild(resizer);
			resizer.addEventListener('mousedown', (e) => startResize(e, index));
		});
	};

	const startResize = (e, columnIndex) => {
		e.preventDefault();
		e.stopPropagation();

		resizeRef.current = {
			isResizing: true,
			startX: e.clientX,
			startWidth: columnWidths[columnIndex],
			columnIndex: columnIndex,
			table: allPdtRef.current
		};

		document.addEventListener('mousemove', handleResize);
		document.addEventListener('mouseup', stopResize);
		document.body.style.cursor = 'col-resize';
		document.body.style.userSelect = 'none';
	};

	const handleResize = (e) => {
		if (!resizeRef.current.isResizing) return;

		const { startX, startWidth, columnIndex, table } = resizeRef.current;
		const diff = e.clientX - startX;
		const newWidth = Math.max(30, startWidth + diff);

		setColumnWidths(prev => {
			const updated = { ...prev, [columnIndex]: newWidth };
			debouncedSetTableWidths(userId, tableName, updated);
			return updated;
		});

		const headers = table.querySelectorAll('thead th');
		const cells = table.querySelectorAll('tbody td');

		headers[columnIndex].style.width = `${newWidth}px`;
		headers[columnIndex].style.minWidth = `${newWidth}px`;
		headers[columnIndex].style.maxWidth = `${newWidth}px`;

		cells.forEach((cell, index) => {
			if (index % headers.length === columnIndex) {
				cell.style.width = `${newWidth}px`;
				cell.style.minWidth = `${newWidth}px`;
				cell.style.maxWidth = `${newWidth}px`;
			}
		});

		// Dynamically set the table's width to the sum of all column widths
		const updatedWidths = { ...columnWidths, [columnIndex]: newWidth };
		const totalWidth = Object.values(updatedWidths).reduce((sum, w) => sum + w, 0);
		table.style.width = `${totalWidth}px`;
	};

	const stopResize = () => {
		resizeRef.current.isResizing = false;
		document.removeEventListener('mousemove', handleResize);
		document.removeEventListener('mouseup', stopResize);
		document.body.style.cursor = '';
		document.body.style.userSelect = '';
	};

	const applyColumnWidths = () => {
		const table = allPdtRef.current;
		if (!table) return;
		const headerRows = table.querySelectorAll('thead tr');
		if (!headerRows.length) return;
		const lastHeaderRow = headerRows[headerRows.length - 1];
		const headers = lastHeaderRow.querySelectorAll('th');
		headers.forEach((header, index) => {
			if (columnWidths[index]) {
				header.style.width = `${columnWidths[index]}px`;
				header.style.minWidth = `${columnWidths[index]}px`;
				header.style.maxWidth = `${columnWidths[index]}px`;
			}
		});
	};

	const getAllPdtList = () => {
		const $table = $(allPdtRef.current);
		const searchValue = $('#searchValue').val();
		if (!$.fn.DataTable.isDataTable($table)) {
			let i = 0;
			$table.DataTable({
				processing: true,
				serverSide: true,
				autoWidth: false,
				ajax: {
					url: `${config.API_URL}/products/getall_product`,
					type: 'POST',
					headers: {
						authorization: `Bearer ${accessToken}`,
					},
					data: function (d) {
						return $.extend({}, d, {
							draw: d.draw,
							start: d.start,
							length: d.length,
							searchValue: searchValue
						});
					},
					dataSrc: function (json) {
						if (json && json.data && Array.isArray(json.data)) {
							setTotalActiveProduct(json.recordsFiltered);
							setTotalboxProduct(json.box_amount_total);
							setTotalpieceProduct(json.piece_amount_total);
						}
						return Array.isArray(json.data) ? json.data : [];
					}
				},
				drawCallback: function () {
					setTimeout(() => {
						applyColumnWidths();
					}, 10);
				},
				language: {
					paginate: {
						first: 'First',
						last: 'Last',
						next: 'Next',
						previous: 'Previous',
					},
					search: 'Search:',
				},
				columns: [
					{
						data: "code",
						width: `${columnWidths[0]}px`,
						render: function (data, type, row) {
							if (!data) return "";
							const shortCode = data.length > 6 ? data.substring(0, 6) + "…" : data;
							return `<span title="${data}">${shortCode}</span>`;
						},
					},
					{
						data: null,
						width: `${columnWidths[1]}px`,
						render: function (data, type, row) {
							return `<span title="${row.name}">${row.name}</span>`;
						},
					},
					{
						data: null,
						width: `${columnWidths[2]}px`,
						render: function (data, type, row) {
							return `<span title="${row.categories}">${row.categories}</span>`;
						},
					},
					{
						data: "brand",
						width: `${columnWidths[3]}px`,
						render: function (data, type, row) {
							if (data === null || data === undefined) {
								return "";
							}
							return data;
						},
					},
					{
						data: null,
						width: `${columnWidths[4]}px`,
						render: function (data, type, row) {
							return `<span title="${row.size}">${row.size}</span>`;
						},
					},
					{ data: "box_cost", width: `${columnWidths[5]}px` },
					{ data: "price", width: `${columnWidths[6]}px` },
					{ data: "box_diff", width: `${columnWidths[7]}px`, className: "text-center" },
					{ data: "quantity", width: `${columnWidths[8]}px` },
					{ data: "piece_cost", width: `${columnWidths[9]}px` },
					{ data: "piece_price", width: `${columnWidths[10]}px` },
					{ data: "piece_diff", width: `${columnWidths[11]}px` },
					{ data: "split_quantity", width: `${columnWidths[12]}px` },
					{
						data: null,
						width: `${columnWidths[13]}px`,
						render: function (data, type, row) {
							const isActive = row.status == "1";
							const toggleText = isActive ? "Active" : "Inactive";
							const toggleClass = isActive ? "text-success" : "text-danger";

							return `
                <div style="display: flex; align-items: center; gap: 10px;">
                  <div class="action-popdot">
                  <a class="icon" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="bi bi-three-dots"></i>
                  </a>
                  <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                    <li>
                    <a href="#" class="toggle-status ${toggleClass}" data-id="${row.id}" data-status="${row.status}">
                      <i class="bi bi-toggle-on"></i> ${toggleText}
                    </a>
                    </li>
                    <li>
                    <a class="deductionbtn reject-btn" href="${config.BASE_URL}/products/edit/${row.id}" title="Edit Product">
                      <i class="bi bi-pencil-square"></i> Edit
                    </a>
                    </li>
                    <li>
                    <a class="deductionbtn reject-btn" href="${config.BASE_URL}/products/previous_pricing/${row.id}" title="Previous Pricing">
                      <i class="bi bi-tags"></i> Previous Pricing
                    </a>
                    </li>
                    <li>
                    <a class="deductionbtn reject-btn" target="_blank" href="${config.BASE_URL}/product/price_sticker/${row.id}" title="Print">
                      <i class="bi bi-printer"></i> Print Sticker
                    </a>
                    </li>
                  </ul>
                  </div>
                </div>`;
						},
					},
				],
				columnDefs: [
					{
						orderable: false,
						targets: '_all'
					},
					{
						targets: 2,
						render: function (data) {
							return data === '1' ? 'Active' : 'Inactive';
						}
					}
				],
				pageLength: 50,
			});

			$table.on('change', '.switch-input', function () {
				const id = $(this).data('id');
				const status = this.checked ? 1 : 0;
				handleChangeStatus(id, status);
			});

			setTimeout(() => {
				initializeResizers();
				applyColumnWidths();
			}, 0);
		} else {
			$table.DataTable().ajax.reload(null, false);
		}
	};

	// Only initialize DataTable after widths are loaded
	useEffect(() => {
		if (accessToken === null) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}
		if (refresh && widthsLoaded) {
			getAllPdtList();
		}
	}, [searchValue, refresh, widthsLoaded]);

	useEffect(() => {
		const handleClickOutside = (e) => {
			if (resizeRef.current.isResizing) {
				e.preventDefault();
				e.stopPropagation();
			}
		};

		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	}, []);

	$(document).on("click", ".toggle-status", function (e) {
		e.preventDefault();

		const id = $(this).data("id");
		const currentStatus = $(this).data("status");
		const newStatus = currentStatus == "0" ? "1" : "0";
		const statusLabel = newStatus == "1" ? "activate" : "Inactivate";

		Swal.fire({
			title: "Are you sure?",
			text: `Do you want to ${statusLabel} this product?`,
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes, change it!",
			cancelButtonText: "Cancel",
		}).then((result) => {
			if (result.isConfirmed) {
				handleChangeStatus(id, newStatus);
			}
		});
	});

	const handleChangeStatus = async (id, status) => {
		const formData = new FormData();
		formData.append('productId', id);
		formData.append('status', status);
		const apiUrl = `${config.API_URL}/products/update_status`;
		try {
			const response = await fetch(apiUrl, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				body: formData,
			});

			if (!response.ok) {
				throw new Error('Failed to change status');
			}

			const data = await response.json();
			console.log(data);

			Swal.fire({
				title: 'Success',
				text: 'Status changed successfully.',
				icon: 'success',
				showConfirmButton: false,
				timer: 1500,
			});

			getAllPdtList();
			const row = $(`#allPdtListTable`).DataTable().row(`[data-id="${id}"]`);
			const rowData = row.data();
			rowData.status = status;
			row.data(rowData).draw(false);

		} catch (error) {
			console.error('Error status change:', error);
		}
	}

	return (
		<>
			<style jsx>{`
        .column-resizer:hover {
          background: rgba(0, 0, 0, 0.1) !important;
        }
        
        .table th {
          border-right: 1px solid #dee2e6;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        
        .table td {
          border-right: 1px solid #dee2e6;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        
        .table {
          table-layout: fixed;
        }
        
        .resizable-table {
          border-collapse: collapse;
        }
        
        .resizable-table th,
        .resizable-table td {
          border: 1px solid #dee2e6;
          box-sizing: border-box;
        }
      `}</style>

			<div style={{ margin: "7px 0 0 0", float: "right" }}>
				<div style={{ margin: "7px 0 0 0", float: "right", position: "relative", zIndex: 1050 }}>
					<ExportProductList totalActiveProduct={totalActiveProduct} urlLink="products/getall_product" pdtStatus="all" />
				</div>
			</div>

			<div style={{ marginTop: "15px", marginBottom: "-28px", fontSize: '15px', fontWeight: 'bold', color: '#333' }}>
				Stock Value Box: {totalboxProduct} &nbsp; | &nbsp; Stock Value Piece: {totalpieceProduct}
				&nbsp; | &nbsp; Total Stock value : {(Number(totalboxProduct) + Number(totalpieceProduct)).toFixed(2)}
			</div>

			<table
				className="table table-bordered dataTable active-tbl resizable-table"
				id="allPdtListTable"
				ref={allPdtRef}
			>
				<thead>
					<tr className="col-span-row">
						<th style={{ width: columnWidths[0], minWidth: columnWidths[0], maxWidth: columnWidths[0], position: 'relative' }}>&nbsp;</th>
						<th style={{ width: columnWidths[1], minWidth: columnWidths[1], maxWidth: columnWidths[1], position: 'relative' }}>&nbsp;</th>
						<th style={{ width: columnWidths[2], minWidth: columnWidths[2], maxWidth: columnWidths[2], position: 'relative' }}>&nbsp;</th>
						<th style={{ width: columnWidths[3], minWidth: columnWidths[3], maxWidth: columnWidths[3], position: 'relative' }}>&nbsp;</th>
						<th style={{ width: columnWidths[4], minWidth: columnWidths[4], maxWidth: columnWidths[4], position: 'relative', borderRight: '1px solid #e27172' }}>&nbsp;</th>
						<th colSpan="4" style={{ textAlign: 'center', width: columnWidths[5] + columnWidths[6] + columnWidths[7] + columnWidths[8], borderLeft: '1px solid #e27172', borderRight: '1px solid #e27172' }}>Box</th>
						<th colSpan="4" style={{ textAlign: 'center', width: columnWidths[9] + columnWidths[10] + columnWidths[11] + columnWidths[12], borderLeft: '1px solid #e27172', borderRight: '1px solid #e27172' }}>Piece</th>
						<th style={{ width: columnWidths[13], minWidth: columnWidths[13], maxWidth: columnWidths[13], position: 'relative' }}>&nbsp;</th>
					</tr>
					<tr className='productrow'>
						<th style={{ width: columnWidths[0], minWidth: columnWidths[0], maxWidth: columnWidths[0], position: 'relative' }}>Code</th>
						<th style={{ width: columnWidths[1], minWidth: columnWidths[1], maxWidth: columnWidths[1], position: 'relative' }}>Name</th>
						<th style={{ width: columnWidths[2], minWidth: columnWidths[2], maxWidth: columnWidths[2], position: 'relative' }}>Category</th>
						<th style={{ width: columnWidths[3], minWidth: columnWidths[3], maxWidth: columnWidths[3], position: 'relative' }}>Brand</th>
						<th style={{ width: columnWidths[4], minWidth: columnWidths[4], maxWidth: columnWidths[4], position: 'relative' }}>Size</th>
						<th style={{ width: columnWidths[5], minWidth: columnWidths[5], maxWidth: columnWidths[5], position: 'relative' }} className='minitable-one'>Cost P</th>
						<th style={{ width: columnWidths[6], minWidth: columnWidths[6], maxWidth: columnWidths[6], position: 'relative' }} className='minitable-one'>Sale P</th>
						<th style={{ width: columnWidths[7], minWidth: columnWidths[7], maxWidth: columnWidths[7], position: 'relative' }} className='minitable-one'>Profit %</th>
						<th style={{ width: columnWidths[8], minWidth: columnWidths[8], maxWidth: columnWidths[8], position: 'relative' }} className='minitable-one'>Qty</th>
						<th style={{ width: columnWidths[9], minWidth: columnWidths[9], maxWidth: columnWidths[9], position: 'relative' }} className='minitable-two'>Cost P</th>
						<th style={{ width: columnWidths[10], minWidth: columnWidths[10], maxWidth: columnWidths[10], position: 'relative' }} className='minitable-two'>Sale P</th>
						<th style={{ width: columnWidths[11], minWidth: columnWidths[11], maxWidth: columnWidths[11], position: 'relative' }} className='minitable-two'>Profit %</th>
						<th style={{ width: columnWidths[12], minWidth: columnWidths[12], maxWidth: columnWidths[12], position: 'relative' }} className='minitable-two'>Qty</th>
						<th style={{ width: columnWidths[13], minWidth: columnWidths[13], maxWidth: columnWidths[13], position: 'relative' }}>Action</th>
					</tr>
				</thead>
				<tbody></tbody>
			</table>
		</>
	);
}

export default AllProductList;